<template>
  <el-form
    ref="formData"
    label-width="150px"
    :model="formData"
    :disabled="!['update', 'create'].includes(formProps.editType)"
  >
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="隐患整改期限" prop="hiddenDangerRectificationPeriod">
          <el-date-picker
            size="small"
            v-model="formData.hiddenDangerRectificationPeriod"
            :disabled="formProps.editType === 'read'"
            type="date"
            class="!w-full"
            placeholder="请选择隐患整改期限"
            value-format="yyyy-MM-dd"
            clearable
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="隐患整改部门" prop="hiddenDangerRectificationDepartmentId">
          <!-- <department-select
            v-model="formData.hiddenDangerRectificationDepartmentId"
            :disabled="formProps.editType === 'read'"
          ></department-select> -->
          <el-select
            v-model="formData.hiddenDangerRectificationDepartmentId"
            filterable
            clearable
            placeholder="请选择隐患整改部门"
            size="small"
            class="w-full"
            :disabled="formProps.editType === 'read'"
          >
            <el-option
              v-for="item in deptList"
              :key="item.DeptId"
              :label="item.DeptName"
              :value="item.DeptId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item
          label="隐患整改负责人"
          prop="personChargeHiddenDangerRectificationId"
          ref="personChargeHiddenDangerRectificationId"
        >
          <!-- <person-select
            v-model="formData.personChargeHiddenDangerRectificationId"
            :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
          ></person-select> -->
          <el-select
            v-model="formData.personChargeHiddenDangerRectificationId"
            class="w-full"
            filterable
            placeholder="请选择隐患整改负责人"
            :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
          >
            <el-option v-for="item in userList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item
          label="隐患验收负责人"
          prop="personChargeHiddenDangerAcceptanceId"
          ref="personChargeHiddenDangerAcceptanceId"
        >
          <person-select
            v-model="formData.personChargeHiddenDangerAcceptanceId"
            :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
          ></person-select>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="风险级别" prop="riskLevel">
          <el-select
            v-model="formData.riskLevel"
            class="w-full"
            placeholder="请选择风险级别"
            filterable
            clearable
            :disabled="formProps.editType === 'read'"
          >
            <el-option
              v-for="item in riskLevelList"
              :key="item.code"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="管控等级" prop="hiddenDangerControlGrade">
          <el-select
            class="w-full"
            placeholder="请输入管控等级"
            v-model="formData.hiddenDangerControlGrade"
            :disabled="formProps.editType === 'read'"
            clearable
          >
            <el-option
              v-for="item in controlHierarchyList"
              :key="item.code"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col> -->

      <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="隐患归属专业" prop="hiddenDangersBelongProfession">
          <el-select
            v-model="formData.hiddenDangersBelongProfession"
            class="w-full"
            placeholder="请选择隐患归属专业"
            filterable
            clearable
            :disabled="formProps.editType === 'read'"
          >
            <el-option
              v-for="item in HiddenBelongProfessionList"
              :key="item.code"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col> -->
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="隐患治理类型" prop="isCheckCorrect">
          <el-select
            v-model="formData.isCheckCorrect"
            class="w-full"
            clearable
            filterable
            :disabled="formProps.editType === 'read'"
          >
            <el-option
              v-for="item in changeTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="所属标段" prop="section">
          <el-select
            v-model="formData.section"
            class="w-full"
            clearable
            filterable
            :disabled="formProps.editType === 'read'"
          >
            <el-option
              v-for="item in sectionList"
              :key="item.code"
              :label="item.code"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="简要原因分析" prop="briefCauseAnalysis">
          <el-input
            type="textarea"
            class="!w-full"
            :rows="4"
            v-model="formData.briefCauseAnalysis"
            placeholder="请输入简要原因分析"
            clearable
            :disabled="formProps.editType === 'read'"
          ></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="整改要求" prop="hiddenDangerVerifierOpinions">
          <el-input
            type="textarea"
            class="!w-full"
            :rows="4"
            v-model="formData.hiddenDangerVerifierOpinions"
            placeholder="请输入整改要求"
            clearable
            :disabled="formProps.editType === 'read'"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import uuid from 'uuid'
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'

import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import DiyService from '../../services/DiyService'
// import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'

const areaApi = new AreaApi()

export default {
  name: 'hidden-ok',
  components: {
    PersonSelect,
    // DepartmentSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'read',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      areaList: [],
      hiddenCategoryList: [],
      HiddenBelongProfessionList: [],
      hiddenLevelList: [],
      controlHierarchyList: [],
      sectionList: [],
      changeTypeList: [
        { label: '立即整改', value: true },
        { label: '期限整改', value: false },
      ],
      riskLevelList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      formData: {},
      rules: {},
      collapseActiveName: ['baseInfo'],
      workFlowDesignId: '', // 流程设计id
      workFlowNodeId: '', // 流程节点id
      deptList: [], // 隐患整改部门列表
      userList: [], // 隐患整改负责人列表
      initUserList: [], // 初始化隐患整改负责人列表
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal))
        } else {
          this.formData = {}
        }
      },
      immediate: true,
    },
    'formData.hiddenDangerRectificationDepartmentId': {
      handler(newValue) {
        this.formData.personChargeHiddenDangerRectificationId = ''
        if (!newValue) {
          this.userList = [...this.initUserList]
          return
        }
        this.userList = this.initUserList.filter((item) => {
          return item.DeptId === newValue
        })
      },
    },
  },
  computed: {},
  async created() {
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenBelongProfession',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
        'DoublePreventionManagement.DataCategory.InfrastructureBidSection',
      ],
      [
        'hiddenLevelList',
        'HiddenBelongProfessionList',
        'hiddenCategoryList',
        'controlHierarchyList',
        'sectionList',
      ],
      this
    )
    await this.getWorkFlowDesign('隐患治理审批主流程')
    await this.getWorkFlowNodes()
    await this.getUserList()
  },
  mounted() {},

  methods: {
    // 获取流程
    async getWorkFlowDesign(name) {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_FlowDesign',
        _PageSize: 15,
        _PageIndex: 1,
        _Where: [{ Name: 'FlowName', Value: name, Type: 'Like' }],
      })
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentFlowDesign = _.find(res.Data, ['FlowName', '隐患治理审批主流程'])
        if (currentFlowDesign) {
          this.workFlowDesignId = currentFlowDesign.Id
        }
      }
    },

    // 获取流程节点
    async getWorkFlowNodes() {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.workFlowDesignId },
      })
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentNode = _.find(res.Data, ['NodeName', '隐患整改'])
        if (currentNode) {
          this.workFlowNodeId = currentNode.Id
        }
      }
    },

    // 获取用户列表
    async getUserList() {
      const [err, res] = await DiyService.getNodeConfirmUsers({
        NodeId: this.workFlowNodeId,
        ApprovalType: 'Agree',
      })
      if (!err && res.Code === 1 && res.Data && res.Data.SelectUsers) {
        this.userList = res.Data.SelectUsers
        this.initUserList = [...res.Data.SelectUsers]
        const deptList = []
        res.Data.SelectUsers.forEach((item) => {
          const dept = deptList.find((deptItem) => {
            return deptItem.DeptName === item.DeptName
          })
          if (!dept && item.DeptId) {
            deptList.push(item)
          }
        })
        this.deptList = [...deptList]
      }
    },

    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
